import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { TeamManagerService } from './../../services/teammanager.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';

/*
    修改返点
    TQQ 2017-01-05
*/
@Component({
    selector: "user-limits",
    templateUrl: "userLimits.html",
    providers: [
        TeamManagerService,
        AlertService
    ]
})
export class UserLimits {
    constructor(
        private viewCtrl: ViewController,
        private teammanager: TeamManagerService,
        private alert: AlertService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private navpar: NavParams) { }

    all =new information;
    limit=new userLimitInput;
    records = [];

    ionViewDidLoad() {    
        this.all=this.navpar.data.information;
        this.teammanager.getUserLimits(this.all.UserName).then(s => {
            this.records = s;
        })
    }


    //确定改变配额
    //chen 2017-01-09
    change(obj) {
        this.teammanager.updateUserLimit(this.all.UserName,obj.Bonus,obj.Limit).then(s=>{
            this.alert.showAlert(s.Error);
        });
    }

    //关闭
    //chen 2017-01-03
    dismiss() {
        this.viewCtrl.dismiss();
    }

    //配额自增
    //chen 2017-01-09
    increase(obj) {
        if (obj.SelfLast >0 && obj.Limit>=0 && obj.Registered>=0) {
            obj.SelfLast--;
            obj.Limit++;
            obj.Registered++;
        }
    }

    //配额自减
    //chen 2017-01-09
    desincrease(obj) {
        if (obj.SelfLast > 0 && obj.Limit>0 && obj.Registered>0) {
            obj.SelfLast++;
            obj.Limit--;
            obj.Registered--;
        }
    }

}


export class information {
    //返点
    Bonus: string;
    //用户名
    UserName: string;
    //用户类型
    UserTypeName: string;
    //用户余额
    UserMoney: Number
}

export class userLimitInput { 
    //用户名
    subUserName: string;
     //返点
    bonus: Number;
    //配额
    limit:Number
}






// WEBPACK FOOTER //
// ./src/pages/teammanager/userLimits.ts